import React from 'react';
import { useAppContext } from '../../context/AppContext';
import './Toast.css';

const Toast = ({ toast, onClose }) => {
  const getIcon = () => {
    switch (toast.type) {
      case 'success':
        return 'fa-check-circle';
      case 'error':
        return 'fa-exclamation-circle';
      case 'warning':
        return 'fa-exclamation-triangle';
      case 'info':
      default:
        return 'fa-info-circle';
    }
  };

  return (
    <div className={`toast toast-${toast.type}`}>
      <div className="toast-icon">
        <i className={`fas ${getIcon()}`}></i>
      </div>
      <div className="toast-message">{toast.message}</div>
      <button className="toast-close" onClick={() => onClose(toast.id)}>
        <i className="fas fa-times"></i>
      </button>
    </div>
  );
};

export default function ToastContainer() {
  const { state, dispatch, actions } = useAppContext();

  const handleClose = (id) => {
    dispatch({ type: actions.REMOVE_TOAST, payload: id });
  };

  if (!state.toasts || state.toasts.length === 0) {
    return null;
  }

  return (
    <div className="toast-container">
      {state.toasts.map(toast => (
        <Toast key={toast.id} toast={toast} onClose={handleClose} />
      ))}
    </div>
  );
}

